// src/components/calendar/WeekView.jsx
import React, { useState } from 'react';
import { Button, Paper, Typography, Box } from '@mui/material';
import { Add as PlusIcon } from '@mui/icons-material';
import EventItem from './EventItem';

const WeekView = ({ currentDate, events, onEventDrop, onAddClick, onEventClick }) => {
    const [draggedEvent, setDraggedEvent] = useState(null);

    // Calcula el inicio de la primera semana
    const startOfFirstWeek = new Date(currentDate);
    startOfFirstWeek.setDate(currentDate.getDate() - currentDate.getDay());

    // Calcula el inicio de la segunda semana (7 días después)
    const startOfSecondWeek = new Date(startOfFirstWeek);
    startOfSecondWeek.setDate(startOfFirstWeek.getDate() + 7);

    // Combina los días de ambas semanas
    const weekDays = Array.from({ length: 14 }, (_, i) => {
        const day = new Date(startOfFirstWeek);
        day.setDate(startOfFirstWeek.getDate() + i);
        return day;
    });

    const handleDragStart = (e, eventData) => {
        e.dataTransfer.setData('text/plain', eventData.id);
        setDraggedEvent(eventData);
    };

    const handleDrop = (date) => {
        if (!draggedEvent) return;

        // Calcula la nueva fecha del evento
        const newStart = new Date(date);
        const oldStart = new Date(draggedEvent.date);
        newStart.setHours(oldStart.getHours(), oldStart.getMinutes());

        // Calcula la duración del evento
        const duration = draggedEvent.end ? new Date(draggedEvent.end) - new Date(draggedEvent.start) : 0;
        const newEnd = new Date(newStart.getTime() + duration);

        // Llama a la función onEventDrop para actualizar el evento
        onEventDrop(draggedEvent.id, newStart, newEnd);
        setDraggedEvent(null);
    };

    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '16px' }}>
            {weekDays.map((day) => (
                <Paper key={day.toISOString()} elevation={1} sx={{ p: 1 }}>
                    <div style={{ borderBottom: '1px solid #e0e0e0', padding: '8px', display: 'flex', justifyContent: 'space-between' }}>
                        <Typography textAlign='left' variant="body2">
                            {day.toLocaleDateString('default', { day: 'numeric' })}
                        </Typography>
                        <Box sx={{ border: 0.3, borderColor: '#e0e0e0', borderRadius: 0.5, solid: '#e0e0e0' }}>
                            {/* Actualización del manejador onClick para ajustar la hora */}
                            <Button
                                variant="text"
                                size="small"
                                sx={{ textAlign: 'right', minWidth: '24px', height: '24px', p: 0 }}
                                onClick={() => {
                                    const adjustedDay = new Date(day);
                                    adjustedDay.setHours(12, 0, 0, 0); // Establece la hora al mediodía
                                    onAddClick(adjustedDay);
                                }}
                            >
                                <PlusIcon fontSize="small" />
                            </Button>
                        </Box>
                    </div>
                    <div
                        style={{ minHeight: '150px' }}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={() => handleDrop(day)}
                    >
                        {events
                            .filter((event) => new Date(event.date).toDateString() === day.toDateString())
                            .map((event) => (
                                <EventItem
                                    key={event.id}
                                    event={event}
                                    onDragStart={handleDragStart}
                                    onEventClick={onEventClick}
                                />
                            ))}
                    </div>
                </Paper>
            ))}
        </div>
    );

};

export default WeekView;
